/* eslint-disable no-mixed-operators */
export function uuidv4() {
  return 'Wi-xxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = parseInt(Math.random() * 16, 10);
    // eslint-disable-next-line no-bitwise
    const v = c === 'x' ? r : (r && 0x3 | 0x8);
    return v.toString(16);
  });
}

export function keyExist(key) {
  return !(key === '' || key === null);
}

export function isIntentKeyword(text) {
  if (text) {
    return text.includes('/') && text.includes('_') && !text.includes(' ');
  }
  return false;
}

export function convertToHyperlink(text) {
  let temp = text;
  const regExp = /(https?:\/\/[^ ]*)/g;
  const matchedArray = [...text.matchAll(regExp)];
  matchedArray.forEach((a) => {
    const url = a[0];
    temp = temp.replaceAll(url, `[${url}](${url})`);
  });
  return temp;
}

/**
 * To convert \n to \n\n
 * because the output can't print nextline with only 1 \n
 */
export function convertToNextline(text) {
  let temp = text;
  const regExp = /([^\n])(\n)([^\n])/g;
  const matchedArray = [...text.matchAll(regExp)];
  matchedArray.forEach((a) => {
    const stringWithNextline = a[0];
    temp = temp.replaceAll(stringWithNextline, stringWithNextline.replace('\n', '\n\n'));
  });
  return temp;
}

export function convertTo2Nextline(text) {
  return text.replaceAll('\n\n', '\n\n &nbsp; \n\n');
}
